import React, {useEffect, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {useParams, useLocation, Navigate} from "react-router-dom";

import {APPCONFIG} from '../../app.config';
import {useForm, useFormErrors, useNav, useUnsavedChangesGuard, useReporte} from '../../components/hooks';
import {APIS} from '../../config/apis';
import { ALERT_TYPE, CUENTA_STATE, OPERATION_MODE, REQUEST_METHOD, ShowToastMessage, dataTaggerActionClear, dataTaggerActionSet } from '@laramie/ui';
import {VALIDATION_MESSAGE} from '../../consts/validationMessage';
import {ServerRequest} from '../../utils/apiweb';

import {Loading, MessageModal, SectionHeading, SectionSidebar} from '../../components/common';
import {getDateId} from '../../utils/convert';
import {CloneObject,OpenObjectURL} from '../../utils/helpers';
import {MenuLateral, SectionForm} from './components';
import {
    AddComercio,
    buildComercioEntityInit,
    FindComercio,
    MakeListDomiciliosRelacionados,
    ModifyBajaCuenta,
    ModifyComercio,
    UpdateEntityRow
} from './utils';
import {FooterButtonVolver} from '../../components/buttons/FooterButtonVolver/FooterButtonVolver';
import {PERMISSIONS} from '../../consts/permissions';

function ComercioView() {

    //parametros url
    const params = useParams();
    const location = useLocation();
    const previousFilters = location.state?.filters;

    //variables
    const entityInit = buildComercioEntityInit();
    const menuesInit = {
        expedientes: false,
        certificadosEscribanos: false,
        relacionesCuentas: false,
        controladoresCuentas: false,
        zonasEntrega: false,
        aplicacionCreditos: false,
        condonacion: false,
        pagosAnticipados: false,
        planesPago: false
    };

    //hooks
    const navigate = useNav()

    const [state, setState] = useState({
        processKey: `Comercio_${params.id ?? 0}_${getDateId()}`,
        id: params.id ? parseInt(params.id) : 0,
        mode: params.mode,
        loading: false,
        entity: entityInit,
        menues: menuesInit,
        showMenu: false,
        tabActive: "declaracionesJuradas",
        tabActiveElementos: ""
    });

    const [zonaTarifariaInmueble, setZonaTarifariaInmueble] = useState({valor: ""});

    const [toggledSidebarLeft, setToggledSidebarLeft] = useState(true);
    const [pendingChange, setPendingChange] = useState(state.mode === OPERATION_MODE.NEW);
    const [message, setMessage] = useState({show: false, text: "", callback: null, id: 0});

    const dispatch = useDispatch();
    const dataTagger = useSelector((state) => state.dataTagger.data);

    const {allowNavigation} = useUnsavedChangesGuard(pendingChange);
    const navigateAllowed = (navOptions) => {
        allowNavigation();
        navigate(navOptions);
    };

    const mount = () => {
        // alta obsoleta: en modo NEW el guard redirige a la grilla, no inicializar ni avisar
        if (state.mode === OPERATION_MODE.NEW) return;
        if (state.id > 0) {
            FindComercio(state, setState, callbackNoSuccess, callbackError, callbackSuccessFindComercio);
        } else {
            dispatch(dataTaggerActionSet(state.processKey, {
                Archivo: [],
                Observacion: [],
                Etiqueta: []
            }));
            ShowToastMessage(ALERT_TYPE.ALERT_WARNING, 'Ingrese los datos y presione siguiente para confirmar el alta');
        }
    }
    useEffect(mount, []);

    const [listExpedientes, setListExpedientes] = useState([]);

    const updateListExpedientes = () => {
        var list = []

        const listsWithExpediente = [
            ...state.entity.recargosDescuentos,
            ...state.entity.inspecciones,
            ...state.entity.habilitacionesComercio
        ];
        listsWithExpediente.filter(f => f.state !== 'r').forEach(x => {
            if (x.idExpediente && x.idExpediente > 0 && list.indexOf(x.idExpediente) === -1) list.push(x.idExpediente)
        });

        setListExpedientes(list);
    }

    useEffect(updateListExpedientes, [state.entity.recargosDescuentos, state.entity.inspecciones, state.entity.rubrosComercio, state.entity.habilitacionesComercio]);

    const [listDireccionesRelacionadas, setListDireccionesRelacionadas] = useState([]);
    const updateListDireccionesRelacionadas = () => {
        MakeListDomiciliosRelacionados(state.entity.vinculosComercio)
            .then(list => {
                setListDireccionesRelacionadas(list);
            })
            .catch((error) => {
                const message = `Error consultando domicilios: ${error.message}`;
                ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
            });
    }
    useEffect(updateListDireccionesRelacionadas, [state.entity.vinculosComercio]);

    const [comercio_formValues, comercio_formHandle, , comercio_formSet] = useForm({
        idEstadoCarga: 20,
        idCuentaInmueble: 0,
        nombreFantasia: "",
        razonSocial: "",
        numeroCuit: "",
        digitoVerificador: "",
        granContribuyente: false,
        idTipoUbicacion: 0

    }, 'comercio_');

    const [cuenta_formValues, cuenta_formHandle, , cuenta_formSet] = useForm({
        numeroCuenta: '',
        numeroWeb: ''
    }, 'cuenta_');

    const [comercioOpen, setComercioOpen] = useState(false);
    const [estadoOpen, setEstadoOpen] = useState(false);
    const { errorOf, validate } = useFormErrors(getErrors);

    //handles
    const cuenta_formHandleProxy = (event) => {
        cuenta_formHandle(event);
        setPendingChange(true);
    }
    const comercio_formHandleProxy = (event) => {
        comercio_formHandle(event);
        setPendingChange(true);
    }
    const handleClickGuardar = () => {
        const errors = getErrors();
        if (errors.numeroCuit || errors.razonSocial) setComercioOpen(true);
        if (errors.idEstadoCarga) setEstadoOpen(true);
        if (!validate()) return;

        if (state.id === 0) {
            AddComercio(state, setState, comercio_formValues, cuenta_formValues, dispatch, navigateAllowed, dataTaggerActionClear, callbackNoSuccess, callbackError)
        } else {
            ModifyComercio(state, setState, dataTagger, comercio_formValues, cuenta_formValues, dispatch, dataTaggerActionClear, callbackNoSuccess, callbackError, callbackSuccessFindComercio);
        }
    };
    const handleClickBaja = () => {
        const idCuenta = state.entity.cuenta.id
        setMessage({
            show: true,
            text: "Al aceptar el cambio se procederá con la baja de la cuenta.",
            callback: () => ModifyBajaCuenta(idCuenta, state, setState, dispatch, navigateAllowed, dataTaggerActionClear, callbackNoSuccess, callbackError),
            id: idCuenta
        });
    }

    //callbacks
    const callbackNoSuccess = (response) => {
        response.json()
            .then((error) => {
                const message = error.message;
                ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
                setState(prevState => {
                    return {...prevState, loading: false};
                });
            })
            .catch((error) => {
                const message = 'Error procesando respuesta: ' + error;
                ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
                setState(prevState => {
                    return {...prevState, loading: false};
                });
            });
    }
    const callbackError = (error) => {
        const message = 'Error procesando solicitud: ' + error.message;
        ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
        setState(prevState => {
            return {...prevState, loading: false};
        });
    }
    const callbackSuccessFindComercio = (response) => {
        response.json()
            .then((data) => {

                //deserialize date fields
                if (data.comercio.fechaCargaInicio) data.comercio.fechaCargaInicio = new Date(data.comercio.fechaCargaInicio);
                if (data.comercio.fechaCargaFin) data.comercio.fechaCargaFin = new Date(data.comercio.fechaCargaFin);
                if (data.cuenta.fechaAlta) data.cuenta.fechaAlta = new Date(data.cuenta.fechaAlta);
                if (data.cuenta.fechaBaja) data.cuenta.fechaBaja = new Date(data.cuenta.fechaBaja);

                data.archivos.forEach(x => {
                    if (x.fecha) x.fecha = new Date(x.fecha);
                });
                data.observaciones.forEach(x => {
                    if (x.fecha) x.fecha = new Date(x.fecha);
                });
                data.variablesCuenta.forEach(x => {
                    if (x.fechaDesde) x.fechaDesde = new Date(x.fechaDesde);
                    if (x.fechaHasta) x.fechaHasta = new Date(x.fechaHasta);
                });
                data.vinculosComercio.forEach(x => {
                    if (x.fechaInstrumentoDesde) x.fechaInstrumentoDesde = new Date(x.fechaInstrumentoDesde);
                    if (x.fechaInstrumentoHasta) x.fechaInstrumentoHasta = new Date(x.fechaInstrumentoHasta);
                });
                data.condicionesEspeciales.forEach(x => {
                    if (x.fechaDesde) x.fechaDesde = new Date(x.fechaDesde);
                    if (x.fechaHasta) x.fechaHasta = new Date(x.fechaHasta);
                });
                data.recargosDescuentos.forEach(x => {
                    if (x.fechaDesde) x.fechaDesde = new Date(x.fechaDesde);
                    if (x.fechaHasta) x.fechaHasta = new Date(x.fechaHasta);
                    if (x.fechaOtorgamiento) x.fechaOtorgamiento = new Date(x.fechaOtorgamiento);
                });
                data.debitosAutomaticos.forEach(x => {
                    if (x.fechaDesde) x.fechaDesde = new Date(x.fechaDesde);
                    if (x.fechaAlta) x.fechaAlta = new Date(x.fechaAlta);
                    if (x.fechaBaja) x.fechaBaja = new Date(x.fechaBaja);
                });
                data.rubrosComercio.forEach(x => {
                    if (x.fechaInicio) x.fechaInicio = new Date(x.fechaInicio);
                    if (x.fechaCese) x.fechaCese = new Date(x.fechaCese);
                    if (x.fechaAltaTransitoria) x.fechaAltaTransitoria = new Date(x.fechaAltaTransitoria);
                    if (x.fechaBajaTransitoria) x.fechaBajaTransitoria = new Date(x.fechaBajaTransitoria);
                    if (x.fechaBaja) x.fechaBaja = new Date(x.fechaBaja);
                });
                data.carteles.forEach(x => {
                    if (x.fechaInicio) x.fechaInicio = new Date(x.fechaInicio);
                    if (x.fechaResolucion) x.fechaResolucion = new Date(x.fechaResolucion);
                    if (x.fechaDDJJ) x.fechaDDJJ = new Date(x.fechaDDJJ);
                    if (x.fechaBaja) x.fechaBaja = new Date(x.fechaBaja);
                });
                data.inspecciones.forEach(x => {
                    if (x.fechaInicio) x.fechaInicio = new Date(x.fechaInicio);
                    if (x.fechaFinalizacion) x.fechaFinalizacion = new Date(x.fechaFinalizacion);
                    if (x.fechaNotificacion) x.fechaNotificacion = new Date(x.fechaNotificacion);
                    if (x.fechaBaja) x.fechaBaja = new Date(x.fechaBaja);
                    if (x.fechaResolucion) x.fechaResolucion = new Date(x.fechaResolucion);
                });
                data.elementos.forEach(x => {
                    if (x.fechaAlta) x.fechaAlta = new Date(x.fechaAlta);
                    if (x.fechaBaja) x.fechaBaja = new Date(x.fechaBaja);
                });
                data.declaracionesJuradas.forEach(x => {
                    if (x.fechaPresentacionDeclaracionJurada) x.fechaPresentacionDeclaracionJurada = new Date(x.fechaPresentacionDeclaracionJurada);
                    if (x.fechaAlta) x.fechaAlta = new Date(x.fechaAlta);
                    if (x.fechaBaja) x.fechaBaja = new Date(x.fechaBaja);
                });
                data.multas.forEach(x => {
                    if (x.fecha) x.fecha = new Date(x.fecha);
                });
                data.habilitacionesComercio.forEach(x => {
                    if (x.fechaHabilitacion) x.fechaHabilitacion = new Date(x.fechaHabilitacion);
                    if (x.fechaVencimiento) x.fechaVencimiento = new Date(x.fechaVencimiento);
                });
                data.espaciosArrendado.forEach(x => {
                    if (x.fechaVigenciaDesde) x.fechaVigenciaDesde = new Date(x.fechaVigenciaDesde);
                    if (x.fechaVigenciaHasta) x.fechaVigenciaHasta = new Date(x.fechaVigenciaHasta);
                    if (x.fechaBaja) x.fechaBaja = new Date(x.fechaBaja);
                });
                data.retenciones.forEach(x => {
                    if (x.fechaPresentacion) x.fechaPresentacion = new Date(x.fechaPresentacion);
                    if (x.fechaAlta) x.fechaAlta = new Date(x.fechaAlta);
                    if (x.fechaBaja) x.fechaBaja = new Date(x.fechaBaja);
                });
                if (data.domicilioComercio) {
                    if (data.domicilioComercio.fechaInicio) data.domicilioComercio.fechaInicio = new Date(data.domicilioComercio.fechaInicio);
                    if (data.domicilioComercio.fechaBaja) data.domicilioComercio.fechaBaja = new Date(data.domicilioComercio.fechaBaja);
                }

                setState(prevState => {
                    return {...prevState, loading: false, entity: data};
                });
                setPendingChange(false);
                comercio_formSet({
                    idEstadoCarga: data.comercio.idEstadoCarga,
                    idCuentaInmueble: data.comercio.idCuentaInmueble,
                    nombreFantasia: data.comercio.nombreFantasia,
                    razonSocial: data.comercio.razonSocial,
                    numeroCuit: data.comercio.numeroCuit,
                    digitoVerificador: data.comercio.digitoVerificador,
                    granContribuyente: data.comercio.granContribuyente,
                    idTipoUbicacion: data.comercio.idTipoUbicacion
                });
                cuenta_formSet({
                    numeroCuenta: data.cuenta.numeroCuenta,
                    numeroWeb: data.cuenta.numeroWeb
                });

                if (data.comercio.idCuentaInmueble) FindZonaTarifariaInmueble(data.comercio.idCuentaInmueble);

                dispatch(dataTaggerActionSet(state.processKey, {
                    Archivo: data.archivos,
                    Observacion: data.observaciones,
                    Etiqueta: data.etiquetas
                }));
            })
            .catch((error) => {
                const message = 'Error procesando respuesta: ' + error;
                ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
                setState(prevState => {
                    return {...prevState, loading: false};
                });
            });
    };

    //funciones
    function makeListDomicilios() {
        let listDomicilios = [];

        if (state.entity.zonasEntrega.length > 0 && state.entity.cuenta.idDireccionEntrega) {
            let direccion = null;
            state.entity.zonasEntrega.forEach(x => {
                if (x.direccion.id === state.entity.cuenta.idDireccionEntrega) {
                    direccion = x.direccion;
                }
            });
            if (direccion) {
                const domicilioEntrega = {...direccion, domicilio: "Entrega"};
                listDomicilios.push(domicilioEntrega);
            }
        }

        return listDomicilios;
    }

    function getErrors() {
        const errors = {};

        if (comercio_formValues.idEstadoCarga === 0) errors.idEstadoCarga = VALIDATION_MESSAGE.REQUIRED_SHORT;
        if (state.mode === OPERATION_MODE.EDIT) {
            if (comercio_formValues.numeroCuit === "") errors.numeroCuit = VALIDATION_MESSAGE.REQUIRED_SHORT;
            else if (comercio_formValues.numeroCuit.length !== 11) errors.numeroCuit = 'Debe tener 11 dígitos';
            if (comercio_formValues.razonSocial.trim() === "") errors.razonSocial = VALIDATION_MESSAGE.REQUIRED;
        }

        return errors;
    }

    function UpdateEntity(typeEntity, row) {
        // o:original a:add m:modify r:remove c:modify only childs
        let entity = CloneObject(state.entity);

        UpdateEntityRow(typeEntity, row, entity);

        setState(prevState => {
            return {...prevState, entity: entity};
        });
        setPendingChange(true);
    }

    function UpdateRubrosComercio(rows) {
        let entity = CloneObject(state.entity);

        let anyDeclaracionesJuradas = entity.declaracionesJuradas.some(x => x.state !== 'o');
        if (anyDeclaracionesJuradas) {
            ShowToastMessage(ALERT_TYPE.ALERT_WARNING, 'Existen Declaraciones juradas sin guardar');
            return
        }

        rows.forEach(row => {
            if (row.state === 'a') {
                entity.rubrosComercio.push(row);
            } else if (row.state === 'm') {
                const index = entity.rubrosComercio.indexOf(entity.rubrosComercio.find(x => x.id === row.id));
                if (index !== -1) {
                    if (row.id < 0) row.state = 'a'; //originalmente era un alta
                    entity.rubrosComercio[index] = row;
                }
            } else if (row.state === 'r') {
                if (row.id < 0) { //lo elimino directamente porque no existe en la bd
                    entity.rubrosComercio = entity.rubrosComercio.filter(f => f.id !== row.id);
                } else {
                    let item = entity.rubrosComercio.find(x => x.id === row.id);
                    item.state = 'r';
                }
            }
        });

        setState(prevState => {
            return {
                ...prevState,
                entity: entity
            };
        });
        setPendingChange(true);
    }

    function SetTabActive(tab) {
        setState(prevState => {
            return {...prevState, tabActive: tab};
        });
    }

    function SetTabActiveElementos(tab) {
        setState(prevState => {
            return {...prevState, tabActiveElementos: tab};
        });
    }

    function ShowPopupMenu(menu) {
        let menues = CloneObject(menuesInit);
        menues[menu] = true;
        setState(prevState => {
            return {...prevState, showMenu: true, menues: menues};
        });
    }

    function HidePopupMenu() {
        setState(prevState => {
            return {...prevState, showMenu: false, menues: menuesInit};
        });
    }

    function ShowPage(partialUrl) {
        const url = APPCONFIG.SITE.WEBAPP + partialUrl + '/' + state.mode + '/' + state.entity.cuenta.id;
        window.open(url, '_blank');
    }

    function refetchComercio() {
        setState(x => ({...x, loading: true}))
        setTimeout(() => {
            FindComercio(state, setState, callbackNoSuccess, callbackError, callbackSuccessFindComercio)
        }, 2000)
    }

    function FindZonaTarifariaInmueble(idCuentaInmueble) {

        const callbackSuccess = (response) => {
            response.json()
                .then((data) => {

                    setZonaTarifariaInmueble({valor: data.valor});
                })
                .catch((error) => {
                    const message = 'Error procesando respuesta: ' + error;
                    ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
                    setState(prevState => {
                        return {...prevState, loading: false};
                    });
                });
        };

        const codigo = 'ZONA_TARIFARIA';
        const paramsUrl = `/${codigo}/cuenta/${idCuentaInmueble}`;

        ServerRequest(
            REQUEST_METHOD.GET,
            null,
            true,
            APIS.URLS.VARIABLE,
            paramsUrl,
            null,
            callbackSuccess,
            callbackNoSuccess,
            callbackError
        );

    }

    // La ficha sale completa y sin diálogo de opciones (contrato del Epic LAR-2347),
    // así que el menú la descarga directo en vez de abrir un modal.
    const [generateFicha, ] = useReporte({
        callback: (reporte, buffer, message, filename) => {
            if (buffer)
                OpenObjectURL(filename ?? `${reporte}.pdf`, buffer);
            else
                ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
        }
    });

    const listMenu = [

        {
            menu: '1', items: [
                {
                    title: 'Expedientes', icon: 'draft', onClick: () => {
                        ShowPopupMenu('expedientes')
                    }
                },
                {
                    title: 'Ficha del comercio', icon: 'description', onClick: () => {
                        generateFicha('CuentaFicha', {idCuenta: state.entity.cuenta.id})
                    }
                }
            ]
        },

        {
            menu: '2', items: [
                {
                    title: 'Gestión', icon: 'gavel', items: [
                        {
                            title: 'Certificados escribanos', onClick: () => {
                                ShowPopupMenu('certificadosEscribanos')
                            }
                        },
                        {
                            title: 'Relaciones', onClick: () => {
                                ShowPopupMenu('relacionesCuentas')
                            }
                        },
                        {
                            title: 'Controladores', onClick: () => {
                                ShowPopupMenu('controladoresCuentas')
                            }
                        },
                        {
                            title: 'Zonas entregas', onClick: () => {
                                ShowPopupMenu('zonasEntrega')
                            }
                        }
                    ]
                },
                {
                    title: 'Movimientos', icon: 'calculate', items: [
                        {
                            title: 'Cuenta corriente', onClick: () => {
                                ShowPage('cuenta-corriente/cuenta')
                            }, permisos: [PERMISSIONS.CUENTA_CORRIENTE_VIEW]
                        },
                        {
                            title: 'Créditos', onClick: () => {
                                ShowPopupMenu('aplicacionCreditos')
                            }, permisos: [PERMISSIONS.CUENTA_PAGO_EDIT, PERMISSIONS.CREDITO_EDIT]
                        },
                        {
                            title: 'Condonaciones', onClick: () => {
                                ShowPopupMenu('condonacion')
                            }, permisos: [PERMISSIONS.CONDONACION_EDIT]
                        },
                        {
                            title: 'Deuda', onClick: () => {
                                ShowPage('deuda')
                            }, permisos: [PERMISSIONS.CUENTA_PAGO_VIEW]
                        },
                        {
                            title: 'Planes de pago', onClick: () => {
                                ShowPopupMenu('planesPago')
                            }, permisos: [PERMISSIONS.CUENTA_PAGO_VIEW]
                        },
                        {
                            title: 'Liquidaciones', onClick: () => {
                                ShowPopupMenu('liquidaciones')
                            }, permisos: [PERMISSIONS.EMISION_EDIT, PERMISSIONS.LIQUIDACION_VIEW]
                        },
                        {
                            // pago-derecho-especial/:idCuenta no sigue el esquema de ShowPage (partialUrl/mode/id), por eso usamos window.open directo.
                            title: 'Derechos especiales', onClick: () => {
                                window.open(`${APPCONFIG.SITE.WEBAPP}pago-derecho-especial/${state.entity.cuenta.id}`, '_blank')
                            }, permisos: [PERMISSIONS.CUENTA_PAGO_EDIT]
                        },
                        {
                            title: 'Informe de deuda', onClick: () => {
                                ShowPopupMenu('informeDeuda')
                            }, permisos: [PERMISSIONS.CUENTA_PAGO_VIEW]
                        }
                    ]
                }
            ]
        },

    ];

    // El alta es por modal desde la grilla; /comercio/new queda obsoleta.
    if (state.mode === OPERATION_MODE.NEW) return <Navigate to={'/comercios' + location.search} replace />;

    return (
        <>

            <Loading visible={state.loading}></Loading>

            {message.show &&
                <MessageModal
                    title={"Confirmación"}
                    message={message.text}
                    onDismiss={() => {
                        setMessage({show: false, text: "", callback: null, id: 0});
                    }}
                    onConfirm={() => {
                        if (message.callback) {
                            message.callback(message.id);
                        }
                        setMessage({show: false, text: "", callback: null, id: 0});
                    }}
                />
            }

            {state.showMenu &&
                <MenuLateral
                    state={state}
                    listExpedientes={listExpedientes}
                    listDireccionesRelacionadas={listDireccionesRelacionadas}
                    UpdateEntity={UpdateEntity}
                    HidePopupMenu={HidePopupMenu}
                />
            }

            <div className='section-frames'>

                <div className='section-sidebar-left'>
                    <SectionSidebar
                        collapsed={toggledSidebarLeft}
                        listMenu={listMenu}
                    />
                </div>

                <div className='section-main'>

                    <SectionHeading
                        handleToggleSidebar={(state.mode !== OPERATION_MODE.NEW) ? () => {
                            setToggledSidebarLeft(prevState => !prevState)
                        } : null}
                        isSidebarOpen={!toggledSidebarLeft}
                        titles={[
                            {title: 'Tributos'},
                            {title: 'Administración de comercios', url: '/comercios'},
                            {
                                title: params.mode === OPERATION_MODE.NEW
                                    ? 'Nuevo'
                                    : `Número de cuenta: ${state.entity.cuenta.numeroCuenta}`
                            }
                        ]}
                    />

                    <SectionForm
                        SetTabActive={SetTabActive}
                        setPendingChange={setPendingChange}
                        state={state}
                        comercio_formValues={comercio_formValues}
                        comercio_formSet={comercio_formSet}
                        comercio_formHandleProxy={comercio_formHandleProxy}
                        cuenta_formValues={cuenta_formValues}
                        cuenta_formHandleProxy={cuenta_formHandleProxy}
                        UpdateEntity={UpdateEntity}
                        UpdateRubrosComercio={UpdateRubrosComercio}
                        zonaTarifariaInmueble={zonaTarifariaInmueble}
                        FindZonaTarifariaInmueble={FindZonaTarifariaInmueble}
                        handleClickBaja={handleClickBaja}
                        errorOf={errorOf}
                        comercioOpen={comercioOpen}
                        setComercioOpen={setComercioOpen}
                        estadoOpen={estadoOpen}
                        setEstadoOpen={setEstadoOpen}
                        pendingChange={pendingChange}
                        refetchComercio={refetchComercio}
                    />

                </div>

            </div>

            <footer className='footer footer-action'>
                <div className='footer-action-container'>
                    <FooterButtonVolver pendingChange={pendingChange} processKey={state.processKey}
                                        filters={previousFilters} to="/comercios"
                                        allowNavigation={allowNavigation}/>
                    {state.mode === OPERATION_MODE.EDIT && state.entity.cuenta.idEstadoCuenta === CUENTA_STATE.ACTIVA &&
                        <button className="btn action-button float-start m-left-20"
                                onClick={(event) => handleClickBaja()}>Baja</button>
                    }
                    {state.mode !== OPERATION_MODE.VIEW &&
                        <button
                            className={pendingChange ? "btn action-button float-end" : "btn action-button btn-disabled float-end"}
                            onClick={(event) => handleClickGuardar()}
                            disabled={!pendingChange}
                        >
                            {(state.mode === OPERATION_MODE.NEW) ? "Siguiente" : "Guardar"}
                        </button>
                    }
                </div>
            </footer>

        </>
    )
}

export default ComercioView;


